import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormulaireContact } from '../models/formulaire.model';
import { environment } from "environments/environment"; let __URL_API__  = `${environment.URL_API}`; 

@Injectable({providedIn: 'root'})
export class FormulaireContactService {

    constructor(private _http: HttpClient) {
    }

    async createIncident(form: FormulaireContact): Promise<string> {
        let formData: FormData = new FormData();
        formData.append('file', form.file == undefined ? "" : form.file);
        formData.append('titre', form.sujet == undefined ? "" : form.sujet.toString());
        //formData.append('nature', form.nature == undefined ? "" : form.nature);
        //formData.append('theme', form.theme == undefined ? "" : form.theme);
        formData.append('description', form.message == undefined ? "" : form.message);

        try {
            let response = await this._http.post(__URL_API__ + 'api/FormulaireContact/ContactServiceClient', formData).toPromise();
            return response as string;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}